/** Product branding (SpectraI EN fork). */
export const PRODUCT_NAME = 'SpectraI'
/** Transparent horizontal logo in frontend/public. Bump ?v= after asset change. */
export const PRODUCT_LOGO_SRC = '/spectrAI.png?v=1'
/** Open Graph / Twitter card image (1200×630). Bump ?v= after asset change. */
export const OG_IMAGE_SRC = '/og-image.png?v=1'
